// src/utils/localIconMap.js (or your preferred path)

// 1. Import your local SVG icons as React Components
//    Adjust the paths based on your project structure.
//import BroomIcon from "../assets/icons/svg/broom.svg";
import { ReactComponent as BroomIconComponent } from "../assets/icons/svg/broom.svg";
import { ReactComponent as BrowsersIconComponent } from "../assets/icons/svg/browsers.svg";

// 2. (Optional) Import any Phosphor icons that you've VERIFIED import reliably
//    and want to include in this primary map.
//import { Moon, Heart, HeartBold } from "phosphor-react";

// Helper function to convert various input strings to PascalCase
// This ensures consistency for the map keys.
const toPascalCase = (str) => {
  if (!str || typeof str !== "string") return "";
  return str
    .toLowerCase() // Start by lowercasing to handle mixed inputs
    .split(/[\s_-]+/) // Split by space, underscore, or hyphen
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join("");
};

export const localIcons = {
  // --- Mappings for your SVG icons ---
  // The key (e.g., "Broom") is what AppIconRenderer will generate from user input
  // like "broom", "Broom", "broom-icon" etc.
  [toPascalCase("broom")]: BroomIconComponent,
  [toPascalCase("browsers")]: BrowsersIconComponent,
  //[toPascalCase("washing-machine")]: WashingMachineIcon,
  //[toPascalCase("washingmachine")]: WashingMachineIcon, // Alias
  // [toPascalCase('my-custom-star')]: MyCustomStar,

  // --- Mappings for directly imported Phosphor icons (use sparingly) ---
  //[toPascalCase("moon")]: Moon,
  //[toPascalCase("heart")]: Heart,
  //[toPascalCase("heart-bold")]: HeartBold, // User types "heart-bold" or "heart bold"

  // Add more mappings here as needed.
  // Key: The PascalCase version of what users might type.
  // Value: The imported icon component.
};
